import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const Home = () => {
  const { user, userProfile, loading } = useAuth();
  const [isMobile, setIsMobile] = useState(false);
  
  // Check for mobile screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  
  const faqs = [
    {
      question: "What is Face Forward Web?",
      answer: "Face Forward Web is a 5-week evidence-based program designed to help individuals manage chronic orofacial pain conditions through educational content and self-management techniques."
    },
    {
      question: "Who can participate in the program?",
      answer: "The program is designed for adults (18+) with chronic orofacial pain conditions who have internet access and English proficiency."
    },
    {
      question: "How long does the program take?",
      answer: "The program is designed to be completed over 5 weeks, with self-paced learning modules that you can complete on your own schedule."
    },
    {
      question: "Is the program based on medical research?",
      answer: "Yes, the program is developed by pain management specialists at Harvard Medical School and Massachusetts General Hospital, using evidence-based techniques."
    }
  ];

  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const navigateToLogin = () => {
    window.location.href = '/login';
  };

  const navigateToDashboard = () => {
    if (userProfile?.role === 'admin') {
      window.location.href = '/admin';
    } else if (userProfile?.role === 'researcher') {
      window.location.href = '/research';
    } else {
      window.location.href = '/dashboard';
    }
  };

  const faqButtonStyle = {
    width: '100%',
    padding: isMobile ? '14px 16px' : '16px 24px',
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    border: 'none',
    fontSize: isMobile ? '14px' : '16px',
    fontWeight: '500',
    color: '#111827',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    outline: 'none',
    fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    margin: '0',
    boxShadow: 'none'
  };

  const faqButtonHoverStyle = {
    ...faqButtonStyle,
    backgroundColor: '#f9fafb'
  };

  return (
    <>
      {/* Add viewport meta and CSS reset for mobile */}
      <style jsx global>{`
        html, body {
          margin: 0;
          padding: 0;
          width: 100%;
          overflow-x: hidden;
        }
        
        * {
          box-sizing: border-box;
        }
        
        @media (prefers-reduced-motion: reduce) {
          img {
            animation: none !important;
          }
        }
      `}</style>
      
      <div className="google-landing-override ffw-typography" style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(180deg, #eef4ff 0%, #dce8ff 46%, #edf4ff 100%)', 
        width: '100%',
        position: 'relative',
        margin: 0,
        padding: 0,
        overflowX: 'hidden'
      }}>
        {/* Header */}
        <header style={{ 
          padding: isMobile ? '12px 16px' : '16px 24px', 
          borderBottom: '1px solid #e8eaed',
          backgroundColor: '#f8fbff',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between', 
            maxWidth: '1200px', 
            margin: '0 auto',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '16px' : '0',
            width: '100%'
          }}>
            {!isMobile && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src="/assets/FFWLOGOtransparent.png" alt="Face Forward Web" style={{ 
                  height: '40px', 
                  width: 'auto', 
                  marginRight: '32px'
                }} />
              </div>
            )}
            
            <nav className="ffw-nav" style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: isMobile ? '20px' : '32px',
              flexWrap: 'wrap',
              justifyContent: isMobile ? 'center' : 'flex-end'
            }}>
              <a href="/" style={{ 
                fontSize: '14px', 
                color: '#202124', 
                textDecoration: 'none', 
                padding: '8px 0',
                borderBottom: '2px solid #4285f4',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}>Home</a>
              <a href="/team" style={{ 
                fontSize: '14px', 
                color: '#5f6368', 
                textDecoration: 'none', 
                padding: '8px 0',
                borderBottom: '2px solid transparent',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#202124';
                e.target.style.borderBottomColor = '#4285f4';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#5f6368';
                e.target.style.borderBottomColor = 'transparent';
              }}>Team</a>
              <a href="/support" style={{ 
                fontSize: '14px', 
                color: '#5f6368', 
                textDecoration: 'none', 
                padding: '8px 0',
                borderBottom: '2px solid transparent',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#202124';
                e.target.style.borderBottomColor = '#4285f4';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#5f6368';
                e.target.style.borderBottomColor = 'transparent';
              }}>Support</a>
              <a href="/participate-flyer" style={{ 
                fontSize: '14px', 
                color: '#5f6368', 
                textDecoration: 'none', 
                padding: '8px 0',
                borderBottom: '2px solid transparent',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#202124';
                e.target.style.borderBottomColor = '#4285f4';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#5f6368';
                e.target.style.borderBottomColor = 'transparent';
              }}>Participate/Refer</a>
              <a href="/login" style={{ 
                fontSize: '14px', 
                color: '#4285f4', 
                textDecoration: 'none', 
                padding: '8px 16px',
                border: '1px solid #4285f4',
                borderRadius: '50px',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#4285f4';
                e.target.style.color = '#ffffff';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#4285f4';
              }}>Sign In</a>
            </nav>
          </div>
        </header>

        {/* Main Content */}
        <main style={{ 
          padding: isMobile ? '64px 16px 48px' : '96px 24px 88px', 
          textAlign: 'center',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          {/* Logo Section */}
          <div style={{ marginBottom: isMobile ? '48px' : '64px' }}>
            <div style={{ 
              marginBottom: isMobile ? '24px' : '48px', 
              display: 'flex', 
              justifyContent: 'center'
            }}>
              <img 
                src="/assets/FFWLOGOtransparent.png" 
                alt="Face Forward Web" 
                style={{ 
                  height: isMobile ? '80px' : '120px',
                  width: 'auto',
                  transition: 'transform 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                }}
              />
            </div>
            <p style={{ 
              fontSize: isMobile ? '14px' : '16px', 
              color: '#5f6368', 
              maxWidth: '680px', 
              margin: isMobile ? '0 auto 32px' : '0 auto 48px',
              lineHeight: '1.6',
              padding: isMobile ? '0 8px' : '0'
            }}>
              This program provides evidence-based strategies to help you manage your chronic orofacial pain.
            </p>

            {/* Trust Logos - Static */}
            <div style={{ 
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '20px' : '120px',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '32px',
              padding: '0 16px'
            }}>
              <img 
                src="/assets/harvardmedical_logo.png" 
                alt="Harvard Medical School" 
                style={{ 
                  height: isMobile ? '32px' : '60px', 
                  width: 'auto',
                  cursor: 'pointer',
                  filter: 'grayscale(30%) brightness(0.85)',
                  transition: 'filter 0.3s ease, transform 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.filter = 'grayscale(0%) brightness(1)';
                  e.target.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.filter = 'grayscale(30%) brightness(0.85)';
                  e.target.style.transform = 'scale(1)';
                }}
              />
              <img 
                src="/assets/mgh_logo.png" 
                alt="Massachusetts General Hospital" 
                style={{ 
                  height: isMobile ? '32px' : '60px', 
                  width: 'auto',
                  cursor: 'pointer',
                  filter: 'grayscale(30%) brightness(0.85)',
                  transition: 'filter 0.3s ease, transform 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.filter = 'grayscale(0%) brightness(1)';
                  e.target.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.filter = 'grayscale(30%) brightness(0.85)';
                  e.target.style.transform = 'scale(1)';
                }}
              />
              <img 
                src="/assets/CHOIRlogo.png" 
                alt="CHOIR" 
                style={{ 
                  height: isMobile ? '32px' : '60px', 
                  width: 'auto',
                  cursor: 'pointer',
                  filter: 'grayscale(30%) brightness(0.85)',
                  transition: 'filter 0.3s ease, transform 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.filter = 'grayscale(0%) brightness(1)';
                  e.target.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.filter = 'grayscale(30%) brightness(0.85)';
                  e.target.style.transform = 'scale(1)';
                }}
              />
            </div>
          </div>

          {/* Single Sign In Button */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            marginBottom: '24px'
          }}>
            <button
              onClick={navigateToLogin}
              style={{
                backgroundColor: '#4285f4',
                color: '#ffffff',
                border: '1px solid #4285f4',
                borderRadius: '24px',
                padding: isMobile ? '12px 20px' : '12px 24px',
                fontSize: isMobile ? '14px' : '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                fontFamily: 'Roboto, arial, sans-serif',
                outline: 'none',
                boxShadow: '0 1px 1px rgba(0,0,0,.1)',
                textAlign: 'center',
                userSelect: 'none',
                whiteSpace: 'nowrap',
                width: isMobile ? '90%' : 'auto',
                maxWidth: isMobile ? '280px' : 'none',
                minWidth: isMobile ? 'auto' : '180px'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#3367d6';
                e.target.style.borderColor = '#3367d6';
                e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,.2)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#4285f4';
                e.target.style.borderColor = '#4285f4';
                e.target.style.boxShadow = '0 1px 1px rgba(0,0,0,.1)';
              }}
            >
              Sign In
            </button>
          </div>
        </main>

        {/* Program Overview */}
        <section style={{ 
          padding: isMobile ? '60px 16px' : '80px 24px', 
          backgroundColor: 'transparent',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ 
              textAlign: 'center', 
              marginBottom: isMobile ? '32px' : '48px'
            }}>
              <h2 style={{ 
                fontSize: isMobile ? '1.8rem' : '2.5rem', 
                fontWeight: '400', 
                color: '#202124', 
                marginBottom: isMobile ? '12px' : '16px',
                fontFamily: 'Product Sans, Arial, sans-serif',
                padding: isMobile ? '0 8px' : '0',
                margin: isMobile ? '0 0 12px 0' : '0 0 16px 0'
              }}>
                Learn evidence-based skills to help manage your orofacial pain
              </h2>
              <p style={{ 
                fontSize: isMobile ? '0.85rem' : '0.9rem', 
                fontWeight: '400', 
                color: '#202124', 
                maxWidth: '600px', 
                margin: isMobile ? '0 auto 32px' : '0 auto 48px',
                lineHeight: '1.6',
                padding: isMobile ? '0 8px' : '0'
              }}>
                Our program combines educational content, self-assessment tools, and clinically validated techniques 
                to support your journey in managing chronic orofacial pain.
              </p>
            </div>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))', 
              gap: isMobile ? '24px' : '32px'
            }}>
              <div className="ffw-panel" style={{ 
                backgroundColor: '#ffffff', 
                padding: isMobile ? '24px' : '32px', 
                borderRadius: '16px',
                textAlign: 'left',
                position: 'relative'
              }}>
                <div style={{ 
                  width: '48px', 
                  height: '48px', 
                  backgroundColor: '#4285f4', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  marginBottom: '16px'
                }}>
                  <svg width="24" height="24" fill="white" viewBox="0 0 24 24">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                  </svg>
                </div>
                <h3 style={{ 
                  fontSize: isMobile ? '18px' : '20px', 
                  fontWeight: '600', 
                  color: '#202124', 
                  marginBottom: '8px',
                  margin: '0 0 8px 0'
                }}>5-Week Program</h3>
                <p style={{ 
                  fontSize: isMobile ? '13px' : '14px', 
                  color: '#5f6368', 
                  lineHeight: '1.6',
                  margin: 0
                }}>Structured learning modules designed for gradual skill building</p>
              </div>
              
              <div className="ffw-panel" style={{ 
                backgroundColor: '#ffffff', 
                padding: isMobile ? '24px' : '32px', 
                borderRadius: '16px',
                textAlign: 'left',
                position: 'relative'
              }}>
                <div style={{ 
                  width: '48px', 
                  height: '48px', 
                  backgroundColor: '#34a853', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  marginBottom: '16px'
                }}>
                  <svg width="24" height="24" fill="white" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                </div>
                <h3 style={{ 
                  fontSize: isMobile ? '18px' : '20px', 
                  fontWeight: '600', 
                  color: '#202124', 
                  marginBottom: '8px',
                  margin: '0 0 8px 0'
                }}>Continuous Learning</h3>
                <p style={{ 
                  fontSize: isMobile ? '13px' : '14px', 
                  color: '#5f6368', 
                  lineHeight: '1.6',
                  margin: 0
                }}>Build skills through daily practice as new sessions unlock each week</p>
              </div>
              
              <div className="ffw-panel" style={{ 
                backgroundColor: '#ffffff', 
                padding: isMobile ? '24px' : '32px', 
                borderRadius: '16px',
                textAlign: 'left',
                position: 'relative'
              }}>
                <div style={{ 
                  width: '48px', 
                  height: '48px', 
                  backgroundColor: '#FBBC04', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  marginBottom: '16px'
                }}>
                  <svg width="24" height="24" fill="white" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                <h3 style={{ 
                  fontSize: isMobile ? '18px' : '20px', 
                  fontWeight: '600', 
                  color: '#202124', 
                  marginBottom: '8px',
                  margin: '0 0 8px 0'
                }}>Evidence-Based</h3>
                <p style={{ 
                  fontSize: isMobile ? '13px' : '14px', 
                  color: '#5f6368', 
                  lineHeight: '1.6',
                  margin: 0
                }}>Clinically validated techniques backed by medical research</p>
              </div>
            </div>
          </div>
        </section>

        {/* Requirements Section with Image */}
        <section style={{ 
          padding: isMobile ? '60px 16px' : '80px 24px', 
          backgroundColor: 'transparent',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
              gap: isMobile ? '32px' : '48px',
              alignItems: 'center'
            }}>
              {/* Image */}
              <div style={{ 
                order: isMobile ? '2' : '1'
              }}>
                <div style={{ 
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  padding: '0',
                  overflow: 'hidden',
                  border: '1px solid rgba(0,0,0,0.1)'
                }}>
                  <div style={{ padding: '0' }}>
                    <img 
                      src="/assets/handsFFWhome.jpeg" 
                      alt="Interactive Learning" 
                      style={{ 
                        width: '100%', 
                        height: isMobile ? '250px' : '400px', 
                        objectFit: 'cover', 
                        objectPosition: 'center top',
                        borderRadius: '16px',
                        padding: isMobile ? '20px' : '30px'
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Requirements */}
              <div style={{ 
                order: isMobile ? '1' : '2',
                textAlign: 'left', 
                padding: isMobile ? '0 8px' : '0' 
              }}>
                <h3 style={{ 
                  fontSize: isMobile ? '18px' : '20px', 
                  fontWeight: '500', 
                  color: '#202124', 
                  marginBottom: '16px',
                  margin: '0 0 16px 0'
                }}>Requirements:</h3>
                <ul style={{ listStyle: 'none', padding: '0', margin: 0 }}>
                  {[
                    "Internet connection and device access",
                    "English language proficiency",
                    "Commitment to 5-week program", 
                    "Age 18 or older"
                  ].map((item, index) => (
                    <li key={index} style={{ 
                      display: 'flex', 
                      alignItems: 'flex-start', 
                      gap: '12px', 
                      marginBottom: '12px' 
                    }}>
                       <svg style={{ 
                         width: isMobile ? '18px' : '20px', 
                         height: isMobile ? '18px' : '20px', 
                         color: '#34a853', 
                         marginTop: '2px', 
                         flexShrink: '0'
                       }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span style={{ 
                        fontSize: isMobile ? '13px' : '14px', 
                        color: '#202124'
                      }}>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section style={{ 
          padding: isMobile ? '60px 16px' : '80px 24px',
          backgroundColor: 'transparent',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ 
              textAlign: 'center', 
              marginBottom: isMobile ? '32px' : '48px'
            }}>
              <h2 style={{ 
                fontSize: isMobile ? '1.6rem' : '32px', 
                fontWeight: '400', 
                color: '#202124', 
                marginBottom: isMobile ? '12px' : '16px',
                fontFamily: 'Product Sans, Arial, sans-serif',
                padding: isMobile ? '0 8px' : '0',
                margin: isMobile ? '0 0 12px 0' : '0 0 16px 0'
              }}>
                Frequently Asked Questions
              </h2>
            </div>
            
            <div style={{ maxWidth: '800px', margin: '0 auto', padding: isMobile ? '0 8px' : '0' }}>
              {faqs.map((faq, index) => (
                <div key={index} style={{ 
                  border: '1px solid #e8eaed', 
                  borderRadius: '8px', 
                  marginBottom: '8px', 
                  overflow: 'hidden', 
                  backgroundColor: '#ffffff' 
                }}>
                  <button
                    style={openFaq === index ? faqButtonHoverStyle : faqButtonStyle}
                    onClick={() => toggleFaq(index)}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = openFaq === index ? '#f8f9fa' : '#ffffff'}
                  >
                    <span>{faq.question}</span>
                    <svg 
                      style={{ 
                        width: isMobile ? '18px' : '20px', 
                        height: isMobile ? '18px' : '20px', 
                        color: '#5f6368', 
                        transition: 'transform 0.2s ease',
                        transform: openFaq === index ? 'rotate(180deg)' : 'rotate(0deg)'
                      }}
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  
                  {openFaq === index && (
                    <div style={{ 
                      padding: isMobile ? '0 16px 16px' : '0 24px 16px', 
                      borderTop: '1px solid #f1f3f4', 
                      backgroundColor: '#ffffff'
                    }}>
                      <p style={{ 
                        color: '#5f6368', 
                        lineHeight: '1.6', 
                        fontSize: isMobile ? '13px' : '14px', 
                        margin: '16px 0 0 0'
                      }}>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer style={{ 
          borderTop: 'none', 
          padding: isMobile ? '32px 16px' : '48px 24px',
          backgroundColor: 'transparent',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: isMobile ? '24px' : '32px'
            }}>
              
              
         
            </div>
            
            <div style={{ 
              marginTop: isMobile ? '24px' : '32px', 
              paddingTop: isMobile ? '16px' : '24px', 
              borderTop: 'none', 
              textAlign: 'center'
            }}>
              <p style={{ 
                fontSize: isMobile ? '11px' : '12px', 
                color: '#5f6368',
                margin: 0
              }}>
                © 2025 Face Forward Web. Developed by Harvard Medical School and Massachusetts General Hospital.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Home;
